import { useEffect, useState } from "react";
import QRCode from "react-qr-code";
import { useDispatch, useSelector } from "react-redux";
import { setMFA } from "../Redux/Slice/Authentication/setMFASlice";
import { useLocation, useNavigate } from "react-router-dom";
import { MobileIcon } from "../Assets/svgs/MobileIcon";
import { ScannerIcon } from "../Assets/svgs/ScannerIcon";
import "../Style/scss/pages/dashboard.scss";
import logo from "../Assets/images/logo.png";
import { Loader } from "../Common/Loader";

export const QRScanner = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [userDetails, setUserDetails] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [token, setToken] = useState("");
  const [backUpCodes, setBackUpCodes] = useState("");
  const redirectUrl = location?.state?.redirectUrl;
  const userData = useSelector((state) => state.login.userData);
  const newUserData = useSelector((state) => state.signUp.userData);
  const forgotPasswordUserData = useSelector(
    (state) => state.forgotPassword.userData
  );
  useEffect(() => {
    if (userData) {
      setUserDetails(userData?.data);
    } else if (newUserData) {
      setUserDetails(newUserData?.data);
    } else if (forgotPasswordUserData) {
      setUserDetails(forgotPasswordUserData?.data);
    }
  }, [userData, newUserData, forgotPasswordUserData]);

  useEffect(() => {
    // if(userDetails){
    setQR();

    // }
  }, []);

  const setQR = async () => {
    setIsLoading(true);
    const result = await dispatch(
      setMFA({
        email: location?.state?.email,
        mfaCredToken: location?.state?.mfaCredToken,
      })
    );
    if (setMFA.fulfilled.match(result) && result?.payload?.success === true) {
      setToken(result?.payload?.data?.qrCodeUrl);
      setBackUpCodes(result?.payload?.data?.backupCodes);
      setIsLoading(false);
    }
    setIsLoading(false);
  };

  return (
    <section className="layoutContainer layoutContainer--full">
      {isLoading ? <Loader /> : ""}
      <div className="layoutGrid">
        <div className="page page--loginOtp">
          <div className="page__head">
            <div className="page__head__logo">
              <img src={logo} alt="Logo | Vox App" />
            </div>
          </div>
          <div className="page__body">
            <div className="emailVerificationCard emailVerificationCard--twoFactorAuthentication w_680">
              <div className="branding">
                <div className="branding__info textCenter">
                  <h1 className="title title--h1">Two Factor Authentication</h1>
                  <p className="text">Follow the instructions below</p>
                </div>
              </div>
              <div className="emailVerificationCard__form">
                <div className="twoFactorCard">
                  <ul className="twoFactorCard__list">
                    <li className="twoFactorCard__list__item">
                      <span className="icon">
                        <ScannerIcon />
                      </span>
                      Scan the QR Code from your mobile app.
                    </li>
                    <li className="twoFactorCard__list__item">
                      <span className="icon">
                        <MobileIcon />
                      </span>
                      After scanning process approve the request at you app end
                      to complete the process.
                    </li>
                  </ul>
                </div>
                <div className="twoFactorCard">
                  <div className="QRCode">
                    <img src={token} alt="" />
                  </div>
                </div>
                <div className="form__button textCenter">
                  <div className="form__optInfo p_0">
                    <p className="para">
                      <a className="link link--underline" onClick={setQR}>
                        Regenerate QR
                      </a>
                    </p>
                    <p className="para">
                      <a
                        className="link link--underline"
                        onClick={() =>
                          navigate("/otpVerification", {
                            state: {
                              email: location?.state?.email,
                              backUpCodes: backUpCodes,
                              from: location.state?.from,
                              isRedirectedFromSignup : location.state?.isRedirectedFromSignup ?? false,
                              redirectUrl,
                            },
                          })
                        }
                      >
                        Go to OTP verification
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
